import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

const ApiService = {
	init() {

		Vue.use(VueAxios, axios)
		this.setHeader()

	},

	setHeader() {

		Vue.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

	},

	async query(resource, params) {

		try {

			return await Vue.axios
				.get(resource,

					{
						params,
						paramsSerializer: ({ params }) => qs.stringify(params, { skipNulls: true, format: 'RFC1738', indices: false })
					})

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	async get(resource, slug = '') {

		try {

			return await Vue.axios.get(`${resource}/${slug}`)

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	async post(resource, params) {

		try {

			return await Vue.axios.post(`${resource}`, params)

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	async update(resource, slug, params) {

		try {

			return await Vue.axios.put(`${resource}/${slug}`, params)

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	async put(resource, params) {

		try {

			return await Vue.axios.put(`${resource}`, params)

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	async delete(resource) {

		try {

			return await Vue.axios.delete(resource)

		} catch(error) {

			var result = { message: this.genericErrorHandling(error) }

			return Promise.reject(result)

		}

	},

	genericErrorHandling(error) {

		var message = error.message

		switch(error.response.status) {

			case 403:
				message = 'Acesso Negado'
				break

		}

		return message

	}

}

export default ApiService



// WEBPACK FOOTER //
// ./src/utils/services/api.service.js